import {Component, ElementRef, EventEmitter, OnDestroy, OnInit, Output, ViewChild} from '@angular/core';
import {BsModalRef} from "ngx-bootstrap/modal";
import {NotificationService} from "../../service/notification.service";
import {HttpCustomService} from "../../../service/http-custom.service";
import {API} from "../../apis/api";
import {takeUntil} from "rxjs/operators";
import {Subject} from "rxjs";
import {NotificationType} from "../../constants/notification-type.enum";
import {CommonConstants} from "../../constants/common-constants.enum";
import {HttpHeaders, HttpResponse} from "@angular/common/http";
import {DownloadFileUtil} from "../../utils/download-file.util";

@Component({
  selector: 'dcu-import-customer',
  templateUrl: './import-customer.component.html',
  styleUrls: ['./import-customer.component.scss']
})
export class ImportCustomerComponent implements OnInit, OnDestroy {

  constructor(
    public dialogRef: BsModalRef,
    private notificationService: NotificationService,
    private httpService: HttpCustomService,
  ) {}

  ngUnsubscribe: Subject<void> = new Subject<void>();
  @ViewChild('singleFile', { static: true }) inputFile: ElementRef;
  files: FileList;
  @Output() newChange: EventEmitter<boolean> = new EventEmitter();


  ngOnInit(): void {
  }

  importCustomer() {
    if (!this.files || !this.files.length) {
      return;
    }
    const file = this.files.item(0);
    const formData: FormData = new FormData();
    formData.append('file', file, file.name);
    const headers = new HttpHeaders({ignoreContentType: ''});
    this.httpService.post({path: API.CUSTOMER_IMPORT}, formData, {headers, responseType: 'blob', observe: 'response'})
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((res: HttpResponse<Blob>) => {
        if (res) {
          this.dialogRef.hide();
          this.notificationService.open({
            type: NotificationType.SUCCESS,
            title: CommonConstants.UPLOAD_SUCCESS_TITLE,
            body: CommonConstants.IMPORT_CUSTOMER_RESULT_MESSAGE
          });
          DownloadFileUtil.download(res);
          this.newChange.emit(true);
        }
    });
    this.inputFile.nativeElement.value = '';
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  onSelectFile(event: any) {
    const inputContext: MSInputMethodContext = event as MSInputMethodContext;
    const target: HTMLInputElement = inputContext.target as HTMLInputElement;
    this.files = target.files;
  }

  downloadTemplate() {
    this.httpService.post({path: API.CUSTOMER_IMPORT_TEMPLE_DOWNLOAD}, null,{responseType: 'blob', observe: 'response'})
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((res: HttpResponse<Blob>) => {
        if (res) {
          DownloadFileUtil.download(res);
        }
      })
  }
}
